<template>
  <q-btn
    v-bind="$attrs"
    :color="color"
    class="gtr-btn"
    unelevated
    @click="$emit('click', $event)"
  >
    <slot />
  </q-btn>
</template>

<script setup>
defineProps({
  color: {
    type: String,
    default: 'positive',
  },
});

defineEmits(['click']);
</script>

<style lang="scss" scoped>
.gtr-btn {
  height: 48px;
  padding: 0 16px;

  @media screen and (min-width: $breakpoint-md-min) {
    padding: 0 48px;
  }
}
</style>
